import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { PollService } from 'src/app/services/poll.service';
import { ProjectService } from 'src/app/services/project.service';
import { RatingService } from 'src/app/services/rating.service';
import { SurveyService } from 'src/app/services/survey.service';
import { ApiInit } from 'src/app/utils/api-init';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ParticipationService } from '../../services/participation.service';
import { CurrentWhiteLabelApplication } from 'src/app/utils/current-white-label-application';
import { TargetPickerService } from '../../services/target-picker.service';
import { AnalyticsType } from 'src/app/enums/analytics-type';
import { NgIf } from '@angular/common';
import {
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonIcon,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  standalone: true,
  imports: [NgIf, TranslateModule, IonTabs, IonTabBar, IonTabButton, IonIcon],
})
export class HomePage implements OnInit {
  private static PARTICIPATION_COUNT_REFRESH_INTERVAL = 180000; // 3min

  public participationOpenCount: number;
  @ViewChildren(IonTabButton) tabButtons: QueryList<IonTabButton>;
  private participationIntervalTimer: number;
  isProjectApp: boolean = false;

  constructor(
    private analyticsService: AnalyticsService,
    private participationService: ParticipationService,
    private apiInit: ApiInit,
    private projectService: ProjectService,
    private ratingService: RatingService,
    private surveyService: SurveyService,
    private pollService: PollService,
    private app: CurrentWhiteLabelApplication,
    private targetPickerService: TargetPickerService
  ) {
    this.isProjectApp = this.app.isProjectApp();
  }

  ngOnInit() {
    this.apiInit.watch(async () => {
      this.loadParticipationOpenCount();
      if (this.isProjectApp) {
        const hasShownModal = +localStorage.getItem('projectAppModal') === 1;

        if (!hasShownModal) {
          this.targetPickerService.presentTargets(this.app.getProjectAppData());
        }
      }
    });
    this.projectService.starChanged$.subscribe(() => {
      setTimeout(() => this.loadParticipationOpenCount(), 500);
    });
    this.ratingService.ratingSubmitted.subscribe((item) => {
      if (item === null) {
        return;
      }
      this.participationOpenCount--;
    });
    this.surveyService.surveySubmitted.subscribe(
      () => this.participationOpenCount--
    );
    this.pollService.pollVoted.subscribe(() => this.participationOpenCount--);
  }

  willChange(event) {
    this.log(event.tab);
  }

  fixTabsForAria() {
    let initialized = false;
    const interval = setInterval(() => {
      this.tabButtons.forEach((btn) => {
        const el: HTMLElement = (btn as any).el;
        const link = el.shadowRoot.querySelector('a');
        if (!link) return;
        el.setAttribute('aria-label', link.getAttribute('aria-label'));
        link.removeAttribute('href');
        link.removeAttribute('aria-selected');
        link.removeAttribute('aria-label');
        link.setAttribute('role', 'none');
        link.setAttribute('aria-hidden', 'true');
        initialized = true;
      });
      if (initialized) clearInterval(interval);
    }, 500);
  }

  ngAfterViewInit() {
    this.fixTabsForAria();
  }

  ionViewDidLeave() {
    clearInterval(this.participationIntervalTimer);
  }

  ionViewDidEnter() {
    this.setParticipationCountIntervalTimer();
  }

  log(to: string) {
    this.analyticsService.logEvent(AnalyticsType.SWITCH_TAB, {
      switched_to: to,
    });
  }

  private loadParticipationOpenCount() {
    this.participationService.getOpenCount().then(
      (n) => {
        this.participationOpenCount = n;
      },
      () => {
        this.participationOpenCount = 0;
      }
    );
  }

  private setParticipationCountIntervalTimer() {
    this.participationIntervalTimer = <any>(
      setInterval(
        () => this.loadParticipationOpenCount(),
        HomePage.PARTICIPATION_COUNT_REFRESH_INTERVAL
      )
    );
  }
}
